import { IonIcon } from '@ionic/react';
import clsx from 'clsx';
import Button from '../../../Button/Button';
import { FunctionalButtonConfig } from '../FunctionalButtonsRow';

interface FunctionalMirrorButtonProps {
  button: FunctionalButtonConfig;
  mirrorClass: string;
}

const FunctionalMirrorButton = ({
  button,
  mirrorClass,
}: FunctionalMirrorButtonProps) => (
  <Button
    disabled={button.disabled}
    fill="clear"
    round={false}
    className={clsx(button.className, mirrorClass)}
  >
    <IonIcon icon={button.icon} slot="start" />
    {button.label}
  </Button>
);

export default FunctionalMirrorButton;
